import React, { useEffect, useRef, useState } from "react"
import { Row, Col, Modal, Button } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/index'
import { ToastContainer, toast } from 'react-toastify';
import config from "../../config/config";
import axios from "axios";

const ConfirmationModal = (props) => {
  const { confirmShow, setConfirmShow, noteUserId, homeEmail, setReloadData, routeName } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseModal = () => {
    setConfirmShow(false)
  }

  useEffect(() => {

  }, [confirmShow])

  const archiveStudentData = async() =>{
    setIsLoading(true)
    let path = config.siteUrl;
    var token = localStorage.getItem('access_token');
    
    const formData = new FormData();
    formData.append("LD_SID", noteUserId)
    formData.append("HOME_EMAIL", homeEmail)
    const res = await axios.post(path + '/classes/'+routeName, formData, {
      headers: {
        'Content-Type': 'Application/json',
        'Accept': 'Application/json',
        'Authorization': ` ${token}`
      }
    })
    // const res = response.data;
    if (res.data.status  === 200) {
      setIsLoading(false)
      toast.success(res?.data?.message)
      setReloadData(true)
      setConfirmShow(false)
    }else {
      console.log(res)
      toast.error('Some error occured.')
      setIsLoading(false)
    }
  }

  // console.log(selectedRow)
  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={confirmShow} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Action</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <div className="alert-modal-box mt-2">
                  <p><strong>Proceed?!</strong></p>
                  <p><strong>This action cannot be undone</strong>, are you sure you wish to proceed?!</p>
                </div>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              archiveStudentData()
            }}>
              Proceed
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default ConfirmationModal